import {AgencyClient, Lang, Store} from 'client/common/types';

export function getIsUserAuthenticated(state: Store): boolean {
    return Boolean(state.user.info?.uid);
}

export function getUserEmail(state: Store): string | undefined {
    return state.user.info?.email;
}

export function getUserQuery(state: Store): {[parameter: string]: string} {
    return state.user.query;
}

export function getUserIsSuperuser(state: Store): boolean {
    return state.user.info?.isSuperuser ?? false;
}

export function getUserIsBrandliftManager(state: Store): boolean {
    return state.user.info?.isBrandliftManager ?? false;
}

export function getUserIsAgency(state: Store): boolean {
    return state.user.info?.authInfo.isAgency ?? false;
}

export function getUserIsAgencyClient(state: Store): boolean {
    return state.user.info?.authInfo.isAgencyClient ?? false;
}

export function getUserHasSurveys(state: Store): boolean {
    return state.user.info?.hasSurveys ?? false;
}

export function getShowBrandliftHeader(state: Store): boolean {
    const query = getUserQuery(state);

    return !query._bl_no_header;
}

export function getAgencyClients(state: Store): AgencyClient[] | undefined {
    return state.user.clients;
}

export function getUserLang(state: Store): Lang {
    return state.user.lang;
}

export function getTestBuckets(state: Store): string[] {
    return state.user.testBuckets;
}
